import request from "@utils/request";
export function orderListApi(data) {
  return request({
    url:
      "/order/bigCarOrder/simpleAuth/front/officialWebsite/orderList?current=1&size=100",
    method: "get",
    // noToken: true,
    params: data,
  });
}

export function orderDetailApi(data) {
  return request({
    url: "/order/bigCarOrder/simpleAuth/front/officialWebsite/orderDetail",
    method: "get",
    // noToken: true,
    params: data,
  });
}

//订单获取支付跳转二维码（前缀/hycanapp）
export function orderPay(data) {
  return request({
    url: "/hycanapp/simpleAuth/front/ssh/order/pay",
    method: "get",
    // noToken: true,
    params: data,
  });
}
